/**
 * # Parameters declarations
 *
 * To be used in granular navigation (one step at a time),
 * or to construct routes/links.
 */
export const ACTIVITY_ID = `:activityId`;
export const SWING = `swing`;
export const SWING_ID = `:swingId`;
export const PLAYBACK = `playback`;
export const LIVE_ANALYSIS = `live-analysis`;
export const PLAYBACK_COMPARISON = `comparison`;
export const VISUALIZER_3D = `3d`;
export const LAYOUT = `layout`;
export const LAYOUT_ID = `:layoutId`;
export const STUDENT_ID = `:studentId`;
export const FLOOR_SETTINGS = `floor-settings`;
export const USER_SETTINGS = `user-settings`;
export const STUDENT_SETTINGS = `student-settings`;
export const CLUBS = `clubs`;
export const TAGS = `tags`;
export const PARAMETERS = `parameters`;
export const ACTIVITIES = `activities`;
export const REPORT = `report`;
export const GOALS = `goals`;
export const GOAL_REPORT = `goalreport`;
